<template lang="pug">
#drawer-historico-agricola
    el-drawer(
        title='Histórico agrícola',
        direction='rtl',
        :visible.sync='show',
        :before-close='drawerHistoricoAgricolaFechar',
        :wrapperClosable='false',
        :modal='false',
        :append-to-body='true'
    )
        template(slot='title', slot-scope='scope')
            .titulo-drawer
                i.mdi.mdi-history
                |
                | {{ $t('mensagens.menuMapa.historicoAgricola') }}

        div(v-if='historicos.length')
            el-table#tabelas-collapse.espacamento-historico(
                @cell-mouse-enter='tabelaHistoricoAgricolaHover',
                @cell-mouse-leave='tabelaHistoricoAgricolaLeaver',
                :data='historicos',
                style='width: 100%'
            )
                el-table-column(:label='$t("mensagens.menuMapa.ciclo")')
                    template(slot-scope='scope')
                        span {{ scope.row.codigoAnoSafra }}
                el-table-column(prop='codigoCultura', :label='$t("mensagens.menuMapa.cultura")')
                el-table-column(width='110')
                    template(slot='header', slot-scope='scope')
                        .text-align-right
                            span {{ $t('mensagens.menuMapa.produtividade') }} (sc/ha | @/ha)
                    template(slot-scope='scope')
                        .text-align-right
                            span {{ scope.row.produtividadeKgHa }}
                el-table-column(width='110')
                    template(slot='header', slot-scope='scope')
                        .text-align-right
                            span {{ $t('mensagens.menuMapa.areaPlantada') }} (ha)
                    template(slot-scope='scope')
                        .text-align-right
                            span {{ scope.row.areaHa }}
        .container-nenhum-resultado-collapse(v-else)
            el-empty(:description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")')
</template>

<script>
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import HistoricoService from '@/services/HistoricoService';

export default {
    name: 'DrawerHistoricoAgricola',

    emits: ['drawerHistoricoAgricolaFechar'],

    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        geometria: {
            type: Object,
            required: true
        },
        mapa: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            resultados: {},
            historicos: [],
            historicoGeometriaHover: null
        };
    },

    async mounted() {
        try {
            if (this.geometria) {
                const bounds = L.geoJSON(this.geometria).getBounds();

                if (bounds) {
                    this.mapa.flyToBounds(bounds, {
                        maxZoom: 13
                    });
                }

                const { data } = await HistoricoService.buscarAgricola(
                    JSON.stringify(this.geometria)
                );
                this.historicos = data;
            }
        } catch (error) {
            this.$notify.error({
                message:
                    'Não foi possível buscar os dados do histórico agrícola'
            });
        }
    },

    methods: {
        drawerHistoricoAgricolaFechar() {
            this.$emit('drawerHistoricoAgricolaFechar');
        },
        tabelaHistoricoAgricolaHover(row) {
            this.historicoGeometriaHover = L.geoJSON(row.geometria, {
                style: () => {
                    return getEstiloGeometria('historicoAgricola');
                }
            });

            this.mapa.addLayer(this.historicoGeometriaHover);
        },
        tabelaHistoricoAgricolaLeaver() {
            this.mapa.removeLayer(this.historicoGeometriaHover);
        }
    }
};
</script>

<style lang="scss">
.el-drawer__body {
    @include scroll-bar();
}

.espacamento-historico {
    height: auto;
}

.titulo-drawer {
    font-size: 18px;
    font-weight: normal;
    color: var(--primary-font-color);
}

.container-nenhum-resultado-collapse {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    i {
        color: #a7a7a7;
        font-size: 30px;
    }
}

#tabelas-collapse {
    font-size: 14px;
    color: var(--primary-font-color);
    tr:nth-child(odd) {
        background-color: var(--selected-background-color);
    }
}

#tabelas-collapse > div.el-table__header-wrapper > table > thead > tr > th {
    font-weight: 500 !important;
    font-size: 14px !important;
    color: var(--primary-font-color) !important;
}

#tabelas-collapse
    > div.el-table__body-wrapper.is-scrolling-none
    > table
    > tbody
    > tr
    > td {
    border: none !important;
}

#tabelas-collapse
    > div.el-table__body-wrapper.is-scrolling-none
    > table
    > tbody
    > tr
    > td
    > .cell
    > span {
    word-break: break-word;
}

#tabelas-collapse > div.el-table__header-wrapper > table > thead > tr > th {
    border: none !important;
}

.text-align-right {
    text-align: right;
}
</style>
